import { render, staticRenderFns } from "./uploadAdjunct2.vue?vue&type=template&id=1a481770"
import script from "./uploadAdjunct2.vue?vue&type=script&lang=js"
export * from "./uploadAdjunct2.vue?vue&type=script&lang=js"
import style0 from "./uploadAdjunct2.vue?vue&type=style&index=0&id=1a481770&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports